module.exports = __webpack_public_path__ + "img/lpfv-sp-4000.15135a1c.png";